export enum FileStatus {
  waitingForFormalControl = 'waitingForFormalControl',
  waitingForContentControl = 'waitingForContentControl',
  accepted = 'accepted',
  acceptedWithRemarks = 'acceptedWithRemarks',
  inspectorRejected = 'inspectorRejected',
  rejected = 'rejected',
}
